/* eslint-disable curly */
const Config = require('~config/default.env').default;
import axios from 'axios';
import { getPlatformType } from '~global/screens';

const ENDPOINTS = {
  GEOCODE: '/geocode/json',
  PLACES: '/place/textsearch/json',
};

const getGoogleServices = () => {
  return new Promise((resolve, reject) => {
    if (window.googleServices) {
      resolve(window.googleServices);
      return;
    }

    const timeout = setTimeout(() => {
      reject(new Error('Google Maps services timed out'));
    }, 10000); // 10 second timeout

    const handleGoogleMapsLoaded = (event) => {
      clearTimeout(timeout);
      resolve(event.detail);
      document.removeEventListener(
        'google-maps-loaded',
        handleGoogleMapsLoaded,
      );
      document.removeEventListener('google-maps-error', handleGoogleMapsError);
    };

    const handleGoogleMapsError = (event) => {
      clearTimeout(timeout);
      reject(new Error(event.detail?.message || 'Google Maps failed to load'));
      document.removeEventListener(
        'google-maps-loaded',
        handleGoogleMapsLoaded,
      );
      document.removeEventListener('google-maps-error', handleGoogleMapsError);
    };

    document.addEventListener('google-maps-loaded', handleGoogleMapsLoaded);
    document.addEventListener('google-maps-error', handleGoogleMapsError);
  });
};

const userShippingsRequest = async (params) => {
  return await axios.get(`${Config.MS_SHIPPING_API_URL}/user/me/shippings`, {
    params: { ...params },
  });
};

const getShippingMethods = (params) =>
  axios.get(`${Config.MS_SHIPPING_API_URL}/user/me/shippings`, { params });
const postUserMeShippings = (payload) =>
  axios.post(`${Config.MS_SHIPPING_API_URL}/user/me/shippings`, payload);

const getPlatformConfig = () => {
  const platform = getPlatformType();

  const configs = {
    ios: {
      headers: { ['x-ios-bundle-identifier']: Config.IOS_BUNDLE_ID },
      apiKey: Config.MAPS_API_KEY_IOS,
      useScript: false,
    },
    android: {
      headers: {
        ['X-Android-Package']: Config.ANDROID_PACKAGE_ID,
        ['X-Android-Cert']: Config.ANDROID_CERTIFICATE,
      },
      apiKey: Config.MAPS_API_KEY_ANDROID,
      useScript: false,
    },
    web: {
      headers: {
        'Content-Type': 'application/json',
      },
      useScript: true,
      apiKey: Config.GOOGLE_MAP_KEY,
      requestConfig: {
        withCredentials: true,
        crossDomain: true,
      },
    },
  };

  return configs[platform];
};

const getAddressFromCoordinates = async (params) => {
  const { useScript } = getPlatformConfig();
  if (useScript) {
    try {
      const { geocoder } = await getGoogleServices();
      return new Promise((resolve, reject) => {
        geocoder.geocode(
          { location: { lat: params?.latitude, lng: params?.longitude } },
          (results, status) => {
            if (status === 'OK') {
              resolve({ data: { results } });
            } else {
              reject(new Error(`Geocoding failed: ${status}`));
            }
          },
        );
      });
    } catch (error) {
      const { headers, apiKey, requestConfig } = getPlatformConfig();
      return axios.get(
        `${Config.API_GOOGLE}${ENDPOINTS.GEOCODE}?latlng=${params?.latitude},${params?.longitude}&key=${apiKey}`,
        {
          headers,
          ...requestConfig,
        },
      );
    }
  }

  const { headers, apiKey, requestConfig } = getPlatformConfig();

  return axios.get(
    `${Config.API_GOOGLE}${ENDPOINTS.GEOCODE}?latlng=${params?.latitude},${params?.longitude}&key=${apiKey}`,
    {
      headers,
      ...requestConfig,
    },
  );
};

const getAddressSuggestions = async (params) => {
  const { useScript } = getPlatformConfig();

  if (useScript) {
    try {
      const { placesAPI } = await getGoogleServices();

      try {
        const response = await placesAPI.findPlaceFromQuery({
          query: params,
          fields: [
            'name',
            'geometry.location',
            'formatted_address',
            'place_id',
            'long_name',
            'district',
          ],
        });

        return { data: { results: response.results || [] } };
      } catch (error) {
        const { headers, apiKey, requestConfig } = getPlatformConfig();
        return axios.get(
          `${Config.API_GOOGLE}${ENDPOINTS.PLACES}?query=${params}&key=${apiKey}&types=address&language=en`,
          {
            headers,
            ...requestConfig,
          },
        );
      }
    } catch (error) {
      const { headers, apiKey, requestConfig } = getPlatformConfig();
      return axios.get(
        `${Config.API_GOOGLE}${ENDPOINTS.PLACES}?query=${params}&key=${apiKey}&types=address&language=en`,
        {
          headers,
          ...requestConfig,
        },
      );
    }
  }

  const { headers, apiKey, requestConfig } = getPlatformConfig();
  return axios.get(
    `${Config.API_GOOGLE}${ENDPOINTS.PLACES}?query=${params}&key=${apiKey}&types=address&language=en`,
    {
      headers,
      ...requestConfig,
    },
  );
};

export default {
  userShippingsRequest,
  getShippingMethods,
  postUserMeShippings,
  getAddressSuggestions,
  getAddressFromCoordinates,
};
